import {
    StatusPill,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeaderCell,
    TableRow,
} from '@/design-system';
import { TENANT_STATUS_LABELS, TENANT_STATUS_TONES, type PlatformTenant } from '@/entities/tenant';
import { formatDayShort } from '@/shared/lib';

import { adminCopy } from '../copy';

export interface TenantTableProps {
    tenants: readonly PlatformTenant[];
    onOpen: (tenant: PlatformTenant) => void;
}

/**
 * De organisaties van het platform. Een rij opent het detail van die
 * organisatie op haar eigen adres (`/admin/organisaties/{uuid}`), zodat een
 * collega een link kan sturen naar precies wat je bedoelt.
 */
export function TenantTable({ tenants, onOpen }: TenantTableProps) {
    return (
        <Table
            columns="minmax(0,1.3fr) 130px 124px minmax(0,1fr) 104px"
            minWidth={760}
            label={adminCopy.tenantsTableLabel}
        >
            <TableHead>
                <TableHeaderCell>{adminCopy.columnName}</TableHeaderCell>
                <TableHeaderCell>{adminCopy.columnPlan}</TableHeaderCell>
                <TableHeaderCell>{adminCopy.columnStatus}</TableHeaderCell>
                <TableHeaderCell>{adminCopy.columnContact}</TableHeaderCell>
                <TableHeaderCell align="end">{adminCopy.columnSince}</TableHeaderCell>
            </TableHead>
            <TableBody>
                {tenants.map((tenant) => (
                    <TableRow key={tenant.uuid} onSelect={() => onOpen(tenant)}>
                        <TableCell emphasis truncate>
                            {tenant.name}
                        </TableCell>
                        <TableCell muted truncate>
                            {tenant.planName ?? adminCopy.noPlan}
                        </TableCell>
                        <TableCell className="py-[9px]">
                            <StatusPill tone={TENANT_STATUS_TONES[tenant.status]} size="sm">
                                {TENANT_STATUS_LABELS[tenant.status]}
                            </StatusPill>
                        </TableCell>
                        <TableCell muted truncate>
                            {tenant.email ?? adminCopy.unknown}
                        </TableCell>
                        <TableCell mono muted align="end">
                            {tenant.createdAt
                                ? formatDayShort(tenant.createdAt)
                                : adminCopy.unknown}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}
